import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';

const ActionTimeline = ({ data, isStreaming = false }) => {
    if (!data || !Array.isArray(data) || data.length === 0) return null;

    // Filter for relevant events to show in timeline
    const timelineEvents = data.filter(event => {
        const type = event?.type || '';
        return type === 'delegation' ||
            type === 'tool_call' ||
            type === 'data-tool_call' ||
            type === 'event' ||
            type === 'data-event' ||
            type === 'node' ||
            type === 'data-node' ||
            type === 'finish';
    });

    if (timelineEvents.length === 0) return null;

    return (
        <div className="space-y-3 pl-4 border-l-2 border-gray-100 my-4 ml-2 mb-6">
            {timelineEvents.map((event, i) => {
                const isLast = i === timelineEvents.length - 1;
                const active = isLast && isStreaming;

                // Since getMessageData now merges ...p.data, we use the event directly as payload
                const sseType = event.sseType || event.type || '';
                const payload = event;
                const normalizedType = sseType.startsWith('data-') ? sseType.slice(5) : sseType;

                return (
                    <div key={i} className="flex items-center gap-3 text-sm text-gray-500 animate-in slide-in-from-left duration-500">
                        {isLast && !isStreaming ? (
                            <CheckCircle2 size={12} className="text-green-500" />
                        ) : (
                            <div className={`w-2 h-2 rounded-full ${active ? 'bg-blue-400 animate-pulse' : 'bg-gray-300'}`} />
                        )}
                        <span className={isLast ? 'text-gray-900 font-medium' : 'text-gray-500'}>
                            {normalizedType === 'delegation'
                                ? `Delegated to ${payload.subagent}`
                                : normalizedType === 'tool_call'
                                    ? `Started ${payload.name?.replace(/_/g, ' ') || 'tool'}`
                                    : normalizedType === 'event'
                                        ? `${payload.subagent ? `${payload.subagent}: ` : ''}${payload.task || payload.name || 'Processing'}`
                                        : normalizedType === 'node'
                                            ? `Transitioned to ${payload.node}`
                                            : normalizedType === 'finish'
                                                ? "Analysis complete"
                                                : "Step completed"}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default ActionTimeline;
